import {widgetProps} from '../../widgets/common';
import {Field} from '../../types/Field';

export function useBusinessDayStartTimeMinutes(field: Field): number {
  return widgetProps<number>(field, 'business_day_start_time_minutes', 0);
}
